// src/config/tags.ts
var TAG_DEFINITIONS = [
  // Model Selection (explicit provider + model mapping)
  {
    key: "model",
    label: "Model",
    description: "AI agent and model to use for generation",
    category: "model",
    inputType: "select",
    options: [
      {
        value: "claude-sonnet-5",
        label: "Claude Sonnet 5",
        description: "Anthropic Claude - Best balance of speed and intelligence",
        logo: "/claude.png",
        provider: "claude-code",
        model: "claude-sonnet-5",
        sdk: "agent"
      },
      {
        value: "claude-opus-4-8",
        label: "Claude Opus 4.8",
        description: "Anthropic Claude - Most capable for complex tasks",
        logo: "/claude.png",
        provider: "claude-code",
        model: "claude-opus-4-8",
        sdk: "agent"
      },
      {
        value: "claude-haiku-4-5",
        label: "Claude Haiku 4.5",
        description: "Anthropic Claude - Fastest, good for iterations",
        logo: "/claude.png",
        provider: "claude-code",
        model: "claude-haiku-4-5",
        sdk: "agent"
      },
      {
        value: "gpt-5.2-codex",
        label: "GPT-5.2 Codex",
        description: "OpenAI Codex - Advanced code generation",
        logo: "/openai.png",
        provider: "openai-codex",
        model: "openai/gpt-5.2-codex",
        sdk: "agent"
      },
      {
        value: "factory-droid-opus",
        label: "Factory Droid (Opus)",
        description: "Factory Droid SDK with Claude Opus 4.8",
        logo: "/factory.svg",
        provider: "factory-droid",
        model: "claude-opus-4-8",
        sdk: "droid"
      },
      {
        value: "factory-droid-codex",
        label: "Factory Droid (Codex)",
        description: "Factory Droid SDK with GPT-5.2 Codex",
        logo: "/factory.svg",
        provider: "factory-droid",
        model: "gpt-5.2-codex",
        sdk: "droid"
      },
      {
        value: "factory-droid-glm",
        label: "Factory Droid (GLM)",
        description: "Factory Droid SDK with GLM 4.7",
        logo: "/factory.svg",
        provider: "factory-droid",
        model: "glm-4.7",
        sdk: "droid"
      }
    ]
  },
  // Framework Selection
  {
    key: "framework",
    label: "Framework",
    description: "Frontend framework to use",
    category: "framework",
    inputType: "select",
    options: [
      {
        value: "next",
        label: "Next.js",
        description: "Full-stack React with SSR, App Router, and file-based routing",
        logo: "/logos/nextjs.svg",
        repository: "github:codyde/template-nextjs",
        branch: "main"
      },
      {
        value: "tanstack",
        label: "TanStack Start",
        description: "Minimal TanStack Start foundation with React 19, Router, Query, and Tailwind",
        logo: "/logos/tanstack.png",
        repository: "github:codyde/template-tanstackstart",
        branch: "main"
      },
      {
        value: "vite",
        label: "React + Vite",
        description: "Fast React SPA with Vite - perfect for client-side apps",
        logo: "/logos/react.svg",
        repository: "github:codyde/template-reactvite",
        branch: "main"
      }
    ],
    promptTemplate: "CRITICAL: You MUST use the {label} template. Clone it using: npx degit {repository}#{branch} {{projectName}}"
  },
  // Runner Selection (options populated dynamically)
  {
    key: "runner",
    label: "Runner",
    description: "Build runner to execute the build",
    category: "runner",
    inputType: "select",
    options: []
    // Populated dynamically from connected runners
  },
  // Design Configuration (nested)
  {
    key: "design",
    label: "Design",
    description: "Visual design preferences",
    category: "design",
    inputType: "nested",
    children: [
      // Brand Themes
      {
        key: "brand",
        label: "Brand",
        description: "Pre-configured brand color themes",
        category: "design",
        inputType: "select",
        maxSelections: 1,
        options: [
          {
            value: "stripe",
            label: "Stripe",
            description: "Modern payments aesthetic",
            logo: "/logos/stripe.svg",
            values: {
              primaryColor: "#635bff",
              secondaryColor: "#0a2540",
              accentColor: "#00d4ff",
              neutralLight: "#f6f9fc",
              neutralDark: "#0a2540"
            }
          },
          {
            value: "vercel",
            label: "Vercel",
            description: "Clean developer tools",
            logo: "/logos/vercel.svg",
            values: {
              primaryColor: "#000000",
              secondaryColor: "#ffffff",
              accentColor: "#0070f3",
              neutralLight: "#fafafa",
              neutralDark: "#000000"
            }
          },
          {
            value: "linear",
            label: "Linear",
            description: "Sleek project management",
            logo: "/logos/linear.svg",
            values: {
              primaryColor: "#5e6ad2",
              secondaryColor: "#26b5ce",
              accentColor: "#f2994a",
              neutralLight: "#f7f8f8",
              neutralDark: "#1a1a1a"
            }
          },
          {
            value: "notion",
            label: "Notion",
            description: "Warm productivity",
            logo: "/logos/notion.svg",
            values: {
              primaryColor: "#2383e2",
              secondaryColor: "#e69138",
              accentColor: "#d44c47",
              neutralLight: "#f7f6f3",
              neutralDark: "#37352f"
            }
          },
          {
            value: "github",
            label: "GitHub",
            description: "Developer-first",
            logo: "/logos/github.svg",
            values: {
              primaryColor: "#238636",
              secondaryColor: "#1f6feb",
              accentColor: "#f85149",
              neutralLight: "#f6f8fa",
              neutralDark: "#24292f"
            }
          },
          {
            value: "airbnb",
            label: "Airbnb",
            description: "Friendly travel",
            logo: "/logos/airbnb.svg",
            values: {
              primaryColor: "#ff385c",
              secondaryColor: "#00a699",
              accentColor: "#fc642d",
              neutralLight: "#f7f7f7",
              neutralDark: "#222222"
            }
          },
          {
            value: "spotify",
            label: "Spotify",
            description: "Bold music streaming",
            logo: "/logos/spotify.svg",
            values: {
              primaryColor: "#1db954",
              secondaryColor: "#191414",
              accentColor: "#1ed760",
              neutralLight: "#f6f6f6",
              neutralDark: "#000000"
            }
          }
        ],
        promptTemplate: "Use the {value} brand aesthetic with the following color palette: Primary: {primaryColor}, Secondary: {secondaryColor}, Accent: {accentColor}, Neutral Light: {neutralLight}, Neutral Dark: {neutralDark}. Match the design style and feel of {value}."
      }
    ]
  }
];
function findTagDefinition(key) {
  for (const def of TAG_DEFINITIONS) {
    if (def.key === key) return def;
    if (def.children) {
      const child = def.children.find((c) => c.key === key);
      if (child) return child;
    }
  }
  return void 0;
}
function getAllTagKeys() {
  const keys = [];
  for (const def of TAG_DEFINITIONS) {
    keys.push(def.key);
    if (def.children) {
      keys.push(...def.children.map((c) => c.key));
    }
  }
  return keys;
}
function getTagsByCategory(category) {
  return TAG_DEFINITIONS.filter((def) => def.category === category);
}
export {
  TAG_DEFINITIONS,
  findTagDefinition,
  getAllTagKeys,
  getTagsByCategory
};
//# sourceMappingURL=tags.js.map